<template>
 <div id="app">
  <div class="form__field">
   <div class="cell">
    <input @keyup.enter="queryResults" class="ids_topicSearch" id="ctl00_ids_contentPlaceHolder_ids_topicSearch" name="ctl00$ids_contentPlaceHolder$ids_topicSearch" placeholder="Search Contents" type="text" v-model="search"/>
   </div>
   <div class="search_button" v-if="search">
    <button @click="clearResult" class="close-icon">
     &times;
    </button>
   </div>
   <div class="search_button">
    <button @click="queryResults">
     <i class="fa fa-search">
     </i>
    </button>
   </div>
  </div>
  <div class="col-1 l-pad-top" id="results">
   <div>
    <p class="toc-2-style" style="margin-bottom: 10px;">
     <strong v-if="resultsCount != 0">
      ({{resultsCount}}) Results Found
     </strong>
     <strong v-else-if="resultsActual">
      No Results Found
     </strong>
    </p>
   </div>
   <div v-for="result of resultsActual">
    <p class="toc-2-style">
     <a :href="result.link" :keywords="result.keywords" onclick="reload(this.href, this.getAttribute('keywords'))">
      {{result.title}}
     </a>
    </p>
    <p class="toc-3-style">
     {{result.desc}}
    </p>
   </div>
  </div>
  <div class="side-toc" v-if="!resultsActual">
   <p class="toc-1-style">
    <a href="cover.html" title="MB2236 MFP">
     MB2236 MFP
    </a>
   </p>
   <p class="toc-1-style">
    <a href="safety.html#safety_ko" title="안전 정보">
     안전 정보
    </a>
   </p>
   <div id="divd0e18">
    <p class="toc-2-style">
     <a href=".html#d0e23" title="표기 규칙">
      표기 규칙
     </a>
    </p>
    <p class="toc-2-style">
     <a href="safety-cable-topic.html#d0e42" title="제품 설명서">
      제품 설명서
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="learning-about-printer-chapter.html#learning-about-printer-chapter_ko" title="프린터에 대한 정보">
     프린터에 대한 정보
    </a>
   </p>
   <div id="divd0e172">
    <p class="toc-2-style">
     <a href="finding-information-about-printer-topic.html#finding-information-about-printer_ko" title="프린터에 대한 정보 찾기">
      프린터에 대한 정보 찾기
     </a>
    </p>
    <p class="toc-2-style">
     <a href="finding-printer-serial-number-topic.html#finding-printer-serial-number_ko" title="프린터 일련 번호 찾기">
      프린터 일련 번호 찾기
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configured-model-topic.html#configured-model_ko" title="프린터 구성">
      프린터 구성
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-control-panel-group.html#d0e379" title="제어판 사용">
      제어판 사용
     </a>
    </p>
    <p class="toc-2-style">
     <a href="customizing-home-screen-topic.html#customizing-home-screen_ko" title="기본 화면 사용자 정의">
      기본 화면 사용자 정의
     </a>
    </p>
    <p class="toc-2-style">
     <a href="changing-language-of-onscreen-keyboard-topic.html#changing-language-of-onscreen-keyboard_ko" title="화면 키보드 언어 변경">
      화면 키보드 언어 변경
     </a>
    </p>
    <p class="toc-2-style">
     <a href="understanding-status-of-power-button-and-indicator-light-topic.html#understanding-status-of-power-button-and-indicator-light_ko" title="전원 버튼 및 표시등 상태의 이해">
      전원 버튼 및 표시등 상태의 이해
     </a>
    </p>
    <p class="toc-2-style">
     <a href="selecting-paper-group.html#d0e759" title="용지 선택">
      용지 선택
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="setting-up-using-home-screen-apps-chapter.html#setting-up-using-home-screen-apps-chapter_ko" title="설정, 설치, 구성">
     설정, 설치, 구성
    </a>
   </p>
   <div id="divd0e1613">
    <p class="toc-2-style">
     <a href="selecting-location-printer-m-topic.html#selecting-location-printer-m_ko" title="프린터 위치 선택">
      프린터 위치 선택
     </a>
    </p>
    <p class="toc-2-style">
     <a href="attaching-cables-topic.html#attaching-cables_ko" title="케이블 연결">
      케이블 연결
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-up-printer-to-fax-group.html#d0e1808" title="팩스에 프린터 설정하기">
      팩스에 프린터 설정하기
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-smtp-server-for-e-mail-topic.html#configuring-smtp-server-for-e-mail_ko" title="이메일 SMTP 설정 구성">
      이메일 SMTP 설정 구성
     </a>
    </p>
    <p class="toc-2-style">
     <a href="loading-paper-and-specialty-media-group.html#d0e3741" title="용지 및 특수 용지 넣기">
      용지 및 특수 용지 넣기
     </a>
    </p>
    <p class="toc-2-style">
     <a href="installing-printer-software-topic.html#d0e3874" title="소프트웨어/드라이버/펌웨어 설치 및 업데이트">
      소프트웨어/드라이버/펌웨어 설치 및 업데이트
     </a>
    </p>
    <p class="toc-2-style">
     <a href="connecting-printer-to-wireless-network-topic.html#d0e4106" title="네트워킹">
      네트워킹
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-cloud-connector-profile-topic.html#creating-cloud-connector-profile_ko" title="Cloud Connector 프로파일 생성">
      Cloud Connector 프로파일 생성
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-menu-settings-page-h1-topic.html#printing-menu-settings-page-h1_ko" title="메뉴 설정 페이지 인쇄">
      메뉴 설정 페이지 인쇄
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="securing-the-printer.html#securing-the-printer_ko" title="프린터 보안">
     프린터 보안
    </a>
   </p>
   <div id="divd0e4624">
    <p class="toc-2-style">
     <a href="erasing-printer-memory-topic.html#erasing-printer-memory_ko" title="프린터 메모리 지우기">
      프린터 메모리 지우기
     </a>
    </p>
    <p class="toc-2-style">
     <a href="restoring-factory-default-settings-topic.html#restoring-factory-default-settings_ko" title="공장 출하 시 기본 설정 복원">
      공장 출하 시 기본 설정 복원
     </a>
    </p>
    <p class="toc-2-style">
     <a href="statement-of-volatility-topic.html#statement-of-volatility_ko" title="휘발성 메모리 설명">
      휘발성 메모리 설명
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="printing-chapter.html#printing-chapter_ko" title="인쇄">
     인쇄
    </a>
   </p>
   <div id="divd0e4746">
    <p class="toc-2-style">
     <a href="printing-from-computer-h2-topic.html#printing-from-computer-h2_ko" title="컴퓨터에서 인쇄">
      컴퓨터에서 인쇄
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-from-mobile-device-using-lexmark-print-topic.html#d0e4772" title="모바일 장치에서 인쇄">
      모바일 장치에서 인쇄
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-from-flash-drive-topic.html#printing-from-flash-drive_ko" title="플래시 드라이브에서 인쇄">
      플래시 드라이브에서 인쇄
     </a>
    </p>
    <p class="toc-2-style">
     <a href="supported-flash-drives-and-file-types-topic.html#supported-flash-drives-and-file-types_ko" title="지원되는 플래시 드라이브 및 파일 유형">
      지원되는 플래시 드라이브 및 파일 유형
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-confidential-jobs-topic.html#configuring-confidential-jobs_ko" title="기밀 작업 구성">
      기밀 작업 구성
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-confidential-and-other-held-jobs-topic.html#printing-confidential-and-other-held-jobs_ko" title="기밀 작업 및 기타 보류 작업 인쇄">
      기밀 작업 및 기타 보류 작업 인쇄
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-from-cloud-connector-profile-topic.html#printing-from-cloud-connector-profile_ko" title="Cloud Connector 프로파일에서 인쇄">
      Cloud Connector 프로파일에서 인쇄
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-font-sample-list-topic.html#printing-font-sample-lis_ko" title="글꼴 샘플 목록 인쇄">
      글꼴 샘플 목록 인쇄
     </a>
    </p>
    <p class="toc-2-style">
     <a href="placing-separator-sheets-topic.html#placing-separator-sheets_ko" title="사본 사이에 간지 삽입">
      사본 사이에 간지 삽입
     </a>
    </p>
    <p class="toc-2-style">
     <a href="canceling-print-job-topic.html#canceling-print-job_ko" title="인쇄 작업 취소">
      인쇄 작업 취소
     </a>
    </p>
    <p class="toc-2-style">
     <a href="adjusting-toner-darkness-topic.html#adjusting-toner-darkness_ko" title="토너 농도 조정">
      토너 농도 조정
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="copying.html#copying_ko" title="복사">
     복사
    </a>
   </p>
   <div id="divd0e5366">
    <p class="toc-2-style">
     <a href="using-ADF-and-scanner-glass-copy-topic.html#using-ADF-and-scanner-glass-copy_ko" title="자동 문서 공급 장치 및 스캐너 유리 사용">
      자동 문서 공급 장치 및 스캐너 유리 사용
     </a>
    </p>
    <p class="toc-2-style">
     <a href="making-copies-topic.html#making-copies_ko" title="복사본 만들기">
      복사본 만들기
     </a>
    </p>
    <p class="toc-2-style">
     <a href="copying-photos-topic.html#copying-photos_ko" title="사진 복사">
      사진 복사
     </a>
    </p>
    <p class="toc-2-style">
     <a href="copying-letterhead-topic.html#copying-letterhead_ko" title="레터헤드지에 복사">
      레터헤드지에 복사
     </a>
    </p>
    <p class="toc-2-style">
     <a href="copying-on-both-sides-of-paper-topic.html#copying-on-both-sides-of-paper_ko" title="용지의 양면에 복사">
      용지의 양면에 복사
     </a>
    </p>
    <p class="toc-2-style">
     <a href="reducing-enlarging-copies-topic.html#reducing-enlarging-copies_ko" title="축소 또는 확대 복사">
      축소 또는 확대 복사
     </a>
    </p>
    <p class="toc-2-style">
     <a href="saving-paper-topic.html#saving-paper_ko" title="한 면에 여러 페이지 복사">
      한 면에 여러 페이지 복사
     </a>
    </p>
    <p class="toc-2-style">
     <a href="collating-copies-topic.html#collating-copies_ko" title="한 부씩 인쇄">
      한 부씩 인쇄
     </a>
    </p>
    <p class="toc-2-style">
     <a href="copying-cards-topic.html#copying-cards_ko" title="카드 복사">
      카드 복사
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-copy-shortcut-topic.html#creating-copy-shortcut_ko" title="복사 단축키 생성">
      복사 단축키 생성
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="e-mailing-chapter.html#e-mailing-chapter_ko" title="이메일">
     이메일
    </a>
   </p>
   <div id="divd0e5696">
    <p class="toc-2-style">
     <a href="using-ADF-and-scanner-glass-email-topic.html#using-ADF-and-scanner-glass-email_ko" title="자동 문서 공급 장치 및 스캐너 유리 사용">
      자동 문서 공급 장치 및 스캐너 유리 사용
     </a>
    </p>
    <p class="toc-2-style">
     <a href="sending-email-topic.html#sending-email_ko" title="이메일 전송">
      이메일 전송
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="Faxing.html#Faxing_ko" title="팩스">
     팩스
    </a>
   </p>
   <div id="divd0e5811">
    <p class="toc-2-style">
     <a href="using-ADF-and-scanner-glass-fax-topic.html#using-ADF-and-scanner-glass-fax_ko" title="자동 문서 공급 장치 및 스캐너 유리 사용">
      자동 문서 공급 장치 및 스캐너 유리 사용
     </a>
    </p>
    <p class="toc-2-style">
     <a href="sending-fax-topic.html#sending-fax_ko" title="팩스 전송">
      팩스 전송
     </a>
    </p>
    <p class="toc-2-style">
     <a href="scheduling-fax-topic.html#sending-fax-scheduled-time_ko" title="팩스 예약">
      팩스 예약
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-fax-destination-shortcut-topic.html#creating-fax-destination-shortcut_ko" title="팩스 대상 단축키 만들기">
      팩스 대상 단축키 만들기
     </a>
    </p>
    <p class="toc-2-style">
     <a href="changing-fax-resolution-topic.html#changing-fax-resolution_ko" title="팩스 해상도 변경">
      팩스 해상도 변경
     </a>
    </p>
    <p class="toc-2-style">
     <a href="adjusting-fax-darkness-topic.html#adjusting-fax-darkness_ko" title="팩스 농도 조정">
      팩스 농도 조정
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-fax-log-topic.html#printing-fax-log_ko" title="팩스 로그 인쇄">
      팩스 로그 인쇄
     </a>
    </p>
    <p class="toc-2-style">
     <a href="blocking-junk-faxes-topic.html#blocking-junk-faxes_ko" title="정크 팩스 차단">
      정크 팩스 차단
     </a>
    </p>
    <p class="toc-2-style">
     <a href="holding-faxes-topic.html#holding-faxes_ko" title="팩스 보류 중">
      팩스 보류 중
     </a>
    </p>
    <p class="toc-2-style">
     <a href="forwarding-fax-topic.html#forwarding-fax_ko" title="팩스 전달">
      팩스 전달
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="FTP.html#FTP_ko" title="스캔">
     스캔
    </a>
   </p>
   <div id="divd0e6205">
    <p class="toc-2-style">
     <a href="using-ADF-and-scanner-glass-scan-topic.html#using-ADF-and-scanner-glass-scan_ko" title="자동 문서 공급 장치 및 스캐너 유리 사용">
      자동 문서 공급 장치 및 스캐너 유리 사용
     </a>
    </p>
    <p class="toc-2-style">
     <a href="scanning-to-computer-topic.html#scanning-to-computer_ko" title="컴퓨터로 스캔">
      컴퓨터로 스캔
     </a>
    </p>
    <p class="toc-2-style">
     <a href="scanning-to-flash-drive-topic.html#scanning-to-flash-drive_ko" title="플래시 드라이브로 스캔">
      플래시 드라이브로 스캔
     </a>
    </p>
    <p class="toc-2-style">
     <a href="scanning-to-ftp-server-using-shortcut-topic.html#scanning-to-ftp-server-using-shortcut_ko" title="FTP 서버로 스캔">
      FTP 서버로 스캔
     </a>
    </p>
    <p class="toc-2-style">
     <a href="scanning-network-folder-using-shortcut-topic.html#scanning-network-folder-using-shortcut_ko" title="네트워크 폴더로 스캔">
      네트워크 폴더로 스캔
     </a>
    </p>
    <p class="toc-2-style">
     <a href="scanning-to-cloud-connector-profile-topic.html#scanning-to-cloud-connector-profile_ko" title="Cloud Connector 프로파일로 스캔">
      Cloud Connector 프로파일로 스캔
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="understanding-printer-menus-chapter.html#understanding-printer-menus-chapter_ko" title="프린터 메뉴 사용">
     프린터 메뉴 사용
    </a>
   </p>
   <div id="divd0e6552">
    <p class="toc-2-style">
     <a href="menu-map-mfp-topic.html#menus-map-mfp_ko" title="메뉴 맵">
      메뉴 맵
     </a>
    </p>
    <p class="toc-2-style">
     <a href="preferences-topic.html#d0e6900" title="장치">
      장치
     </a>
    </p>
    <p class="toc-2-style">
     <a href="layout-topic.html#d0e8536" title="인쇄">
      인쇄
     </a>
    </p>
    <p class="toc-2-style">
     <a href="tray-configuration-topic.html#d0e9328" title="용지">
      용지
     </a>
    </p>
    <p class="toc-2-style">
     <a href="copy-defaults-topic.html#d0e9629" title="복사">
      복사
     </a>
    </p>
    <p class="toc-2-style">
     <a href="fax-defaults-subgroup.html#d0e9851" title="팩스">
      팩스
     </a>
    </p>
    <p class="toc-2-style">
     <a href="email-setup-topic.html#d0e11473" title="이메일">
      이메일
     </a>
    </p>
    <p class="toc-2-style">
     <a href="ftp-defaults-topic.html#d0e12156" title="FTP">
      FTP
     </a>
    </p>
    <p class="toc-2-style">
     <a href="flash-drive-scan-topic.html#d0e12588" title="USB 드라이브">
      USB 드라이브
     </a>
    </p>
    <p class="toc-2-style">
     <a href="network-overview-topic.html#d0e13193" title="네트워크/포트">
      네트워크/포트
     </a>
    </p>
    <p class="toc-2-style">
     <a href="login-methods-subgroup.html#d0e15208" title="보안">
      보안
     </a>
    </p>
    <p class="toc-2-style">
     <a href="cloud-connector-menu-topic.html#cloud-connector-menu_ko" title="Cloud Connector">
      Cloud Connector
     </a>
    </p>
    <p class="toc-2-style">
     <a href="menu-settings-page-topic.html#d0e15922" title="보고서">
      보고서
     </a>
    </p>
    <p class="toc-2-style">
     <a href="troubleshooting-menu-topic.html#troubleshooting-menu_ko" title="문제 해결">
      문제 해결
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="maintain-printer-chapter.html#maintain-printer-chapter_ko" title="프린터 유지관리">
     프린터 유지관리
    </a>
   </p>
   <div id="divd0e16214">
    <p class="toc-2-style">
     <a href="checking-status-of-parts-and-supplies-topic.html#checking-status-of-parts-and-supplies_ko" title="부품 및 소모품 상태 확인">
      부품 및 소모품 상태 확인
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-supply-notifications-topic.html#configuring-supply-notifications_ko" title="소모품 알림 구성">
      소모품 알림 구성
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-up-e-mail-alert-topic.html#setting-up-e-mail-alert_ko" title="이메일 경고 설정">
      이메일 경고 설정
     </a>
    </p>
    <p class="toc-2-style">
     <a href="viewing-reports-topic.html#viewing-reports_ko" title="보고서 보기">
      보고서 보기
     </a>
    </p>
    <p class="toc-2-style">
     <a href="ordering-supplies-group.html#ordering-supplies-group_ko" title="부품 및 소모품 주문">
      부품 및 소모품 주문
     </a>
    </p>
    <p class="toc-2-style">
     <a href="replacing-toner-cartridge-topic.html#d0e16485" title="부품 및 소모품 교체">
      부품 및 소모품 교체
     </a>
    </p>
    <p class="toc-2-style">
     <a href="cleaning-printer-topic.html#d0e16630" title="프린터 부품 청소">
      프린터 부품 청소
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-power-save-mode-settings-topic.html#d0e16718" title="에너지 및 용지 절약">
      에너지 및 용지 절약
     </a>
    </p>
    <p class="toc-2-style">
     <a href="moving-printer-topic.html#moving-printer_ko" title="프린터를 다른 장소로 옮기기">
      프린터를 다른 장소로 옮기기
     </a>
    </p>
    <p class="toc-2-style">
     <a href="shipping-printer-topic.html#shipping-printer_ko" title="프린터 운송">
      프린터 운송
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="troubleshooting-chapter.html#troubleshooting-chapter_ko" title="문제 해결">
     문제 해결
    </a>
   </p>
   <div id="divd0e16878">
    <p class="toc-2-style">
     <a href="print-quality-problems-topic.html#print-quality-problems_ko" title="인쇄 품질 문제">
      인쇄 품질 문제
     </a>
    </p>
    <p class="toc-2-style">
     <a href="print-quality-is-poor-subgroup.html#d0e16989" title="인쇄 문제">
      인쇄 문제
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-printer-not-responding-topic.html#trb-printer-not-responding_ko" title="프린터가 응답하지 않음">
      프린터가 응답하지 않음
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-unable-to-read-flash-drive-topic.html#trb-unable-to-read-flash-drive_ko" title="플래시 드라이브를 읽을 수 없음">
      플래시 드라이브를 읽을 수 없음
     </a>
    </p>
    <p class="toc-2-style">
     <a href="enabling-usb-port-topic.html#enabling-usb-port_ko" title="USB 포트 활성화">
      USB 포트 활성화
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-cannot-open-embedded-web-server-topic.html#d0e19596" title="네트워크 연결 문제">
      네트워크 연결 문제
     </a>
    </p>
    <p class="toc-2-style">
     <a href="message-replace-cartridge-printer-region-mismatch-topic.html#d0e19814" title="소모품 관련 문제">
      소모품 관련 문제
     </a>
    </p>
    <p class="toc-2-style">
     <a href="clearing-jams.html#clearing-jams_ko" title="용지 걸림 해결">
      용지 걸림 해결
     </a>
    </p>
    <p class="toc-2-style">
     <a href="solving-printer-problems.html#solving-printer-problems_ko" title="급지 문제">
      급지 문제
     </a>
    </p>
    <p class="toc-2-style">
     <a href="disabling-smtp-server-not-setup-error-topic.html#d0e20592" title="이메일로 문제 보내기">
      이메일로 문제 보내기
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-caller-id-not-shown-topic.html#d0e20711" title="팩스 문제">
      팩스 문제
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-cannot-scan-to-computer-topic.html#d0e21366" title="스캔 문제">
      스캔 문제
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-contacting-customer-support-topic.html#trb-contacting-customer-support_ko" title="고객 지원 문의">
      고객 지원 문의
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="recycle-dispose-chapter.html#recycle-dispose-chapter_ko" title="재활용 및 폐기 처리">
     재활용 및 폐기 처리
    </a>
   </p>
   <div id="divd0e22121">
    <p class="toc-2-style">
     <a href="recycling-lexmark-products-topic.html#recycling-lexmark-products_ko" title="Lexmark 제품 재활용">
      Lexmark 제품 재활용
     </a>
    </p>
    <p class="toc-2-style">
     <a href="recycling-lexmark-packaging-topic.html#recycling-lexmark-packaging_ko" title="Lexmark 포장재 재활용">
      Lexmark 포장재 재활용
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="laser_ug_notices.html#laser_ug_notices_ko" title="고지사항">
     고지사항
    </a>
   </p>
   <div id="divd0e22156">
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e22159" title="제품 정보">
      제품 정보
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e22176" title="발행 공지">
      발행 공지
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#trademarks_ko" title="상표">
      상표
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#licensing-notices_ko" title="라이센스 관련 고지사항">
      라이센스 관련 고지사항
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#noise-emission-levels_ko" title="음향 배출 수준">
      음향 배출 수준
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#product-disposal_ko" title="제품 폐기">
      제품 폐기
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#static-sensitivity-notice_ko" title="정전기 감도 알림">
      정전기 감도 알림
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#energy-star_ko" title="ENERGY STAR">
      ENERGY STAR
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#temperature-information_ko" title="온도 정보">
      온도 정보
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#laser-notice_ko" title="레이저 고지사항">
      레이저 고지사항
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#power-consumption_ko" title="전력 소비량">
      전력 소비량
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#regulatory-notices-for-telecommunication-terminal-equipment_ko" title="통신 터미널 장비에 대한 규제 관련 공지">
      통신 터미널 장비에 대한 규제 관련 공지
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e22493" title="무선 제품에 대한 규제 관련 공지">
      무선 제품에 대한 규제 관련 공지
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#modular-component-notice_ko" title="모듈식 구성 요소 공지">
      모듈식 구성 요소 공지
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#exposure-to-radio-frequency-radiation_ko" title="무선 주파수 방사선 노출">
      무선 주파수 방사선 노출
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#korean-kc-statement-2_ko" title="한국 KC 인증서">
      한국 KC 인증서
     </a>
    </p>
   </div>
  </div>
 </div>
</template>
<script>
 import output from './output.json';

const fuzzysort = require('fuzzysort');
const lunr = require("lunr")
require("lunr-languages/lunr.stemmer.support.js")(lunr)
require('lunr-languages/lunr.multi')(lunr)
require("lunr-languages/tinyseg.js")(lunr)
require("lunr-languages/lunr.de.js")(lunr)
require("lunr-languages/lunr.es.js")(lunr)
require("lunr-languages/lunr.fr.js")(lunr)
require("lunr-languages/lunr.it.js")(lunr)
require("lunr-languages/lunr.ja.js")(lunr)
require("lunr-languages/lunr.pt.js")(lunr)

export default {
  name: 'app',
  data() {
    return {
        search: '',
        resultsActual: '',
        list: output,
        resultsCount: 0,
    }
  },

  methods: { queryResults() {

      if (this.search.trim() === ''){
        return  '';
      }
    //   else if(this.search.trim().length < 3){
    //     this.resultsActual = new Array();
    //     this.resultsCount = 0;
    //   }
      else {
        var documents = this.list;

        var idx = lunr(function () {
            this.use(lunr.ja);
            this.use(lunr.multiLanguage('en', 'de', 'es', 'fr', 'it', 'ja', 'pt'))
            this.ref('UUID');
            this.field('title');
            this.field('descFull');
            this.metadataWhitelist = ['position'];

            documents.forEach(function (doc) {
                        this.add(doc)
                    },this);
            });
        

        var searchTerms = this.search.replace(/[`~!#$%^&*()|+\-=?;:'",.<>\{\}\[\]\\/]/gi, ' ').trim().replace(/\s\s+/g, " ");
        // var searchTerms = this.search;
        searchTerms = this.removeStopWords(searchTerms);
        var searchRawTerms = searchTerms;
        // searchTerms  =  searchTerms.split(" ").join(" +");
        // searchTerms = searchTerms.startsWith(" +") ? searchTerms : "+" + searchTerms;

        console.log(searchTerms);
        var results = idx.search(searchTerms);

        console.log (results);

        results = results.map(res => {
            var linkRes =  documents.find(elem => elem.UUID == res.ref);
            var keywords_array = new Array();
            var keywords_arrays = new Array();
            var keywords_arrays_title = new Array();

            Object.keys(res.matchData.metadata).map(kys => {
                var positions_title = res.matchData.metadata[kys].title;
                var positions_desc = res.matchData.metadata[kys].descFull;

                if(typeof positions_title !== 'undefined' ){
                    positions_title.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays_title.push(val[0],val[1]);
                    });
                }

                if(typeof positions_desc !== 'undefined' ){
                    positions_desc.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays.push(val[0],val[1]);
                    });
                }
            });

            

            res.link = linkRes.link;
            res.desc = linkRes.desc;
            res.title = linkRes.title;
            res.full = linkRes.descFull;
            res.titleArray = keywords_arrays_title;
            res.descArray = keywords_arrays;
            keywords_array = keywords_array.filter(function(item, index){ 
                return searchRawTerms.indexOf(item) >= 0;
            });
            var keywords_set = new Set(keywords_array);
            res.keywords = [...keywords_set].toString();
            // res.keywords = ["ramon","joe","gudz"]
            return res;
        });
        
        var existingPagesInResult = new Array();
        

       
        results = results.filter(function(item, index){
                
            if(existingPagesInResult.includes(item.link)){
                
                return false;
            }
            else { 
                existingPagesInResult.push(item.link);
                return true;
            }

            if(res.keywords == ""){
                return false;
            }
        });

        

        console.log (results);
        this.resultsActual = results;
        this.resultsCount = results.length;
      }
    },

    clearResult: function(){
        this.search = "";
        this.resultsActual = undefined;
        this.resultsCount = 0;
        reload("cover.html", "");
       
    },  

    removeStopWords: function(queryString) {
        const stopWords = ['i', 'me', 'my', 'myself', 'we', 'our', 'ours', 'ourselves', 'you', "you're", "you've", "you'll", "you'd", 'your', 'yours', 'yourself', 'yourselves', 
        'he', 'him', 'his', 'himself', 'she', "she's", 'her', 'hers', 'herself', 'it', "it's", 'its', 'itself', 'they', 'them', 'their', 'theirs', 'themselves', 'what', 'which', 
        'who', 'whom', 'this', 'that', "that'll", 'these', 'those', 'am', 'is', 'are', 'was', 'were', 'be', 'been', 'being', 'have', 'has', 'had', 'having', 'do', 'does', 'did', 
        'doing', 'a', 'an', 'the', 'and', 'but', 'if', 'or', 'because', 'as', 'until', 'while', 'of', 'at', 'by', 'for', 'with', 'about', 'against', 'between', 'into', 'through', 
        'during', 'before', 'after', 'above', 'below', 'to', 'from', 'up', 'down', 'in', 'out', 'on', 'off', 'over', 'under', 'again', 'further', 'then', 'once', 'here', 'there', 
        'when', 'where', 'why', 'how', 'all', 'any', 'both', 'each', 'few', 'more', 'most', 'other', 'some', 'such', 'no', 'nor', 'not', 'only', 'own', 'same', 'so', 'than', 'too', 
        'very', 's', 't', 'can', 'will', 'just', 'don', "don't", 'should', "should've", 'now', 'd', 'll', 'm', 'o', 're', 've', 'y', 'ain', 'aren', "aren't", 'couldn', "couldn't", 
        'didn', "didn't", 'doesn', "doesn't", 'hadn', "hadn't", 'hasn', "hasn't", 'haven', "haven't", 'isn', "isn't", 'ma', 'mightn', "mightn't", 'mustn', "mustn't", 'needn', 
         "needn't", 'shan', "shan't", 'shouldn', "shouldn't", 'wasn', "wasn't", 'weren', "weren't", 'won', "won't", 'wouldn', "wouldn't"]

        var cleanQueryString = new Array();
        queryString.split(" ").forEach(word => {
             if(!stopWords.includes(word)) {
                 cleanQueryString.push(word);
             }
        });

        return cleanQueryString.join(" ");
    },
    
  }
}
</script>


// WEBPACK FOOTER //
// src/App.vue